module.exports = __webpack_public_path__ + "img/avatar0.948c138e.png";